import { t } from 'ttag'
import { useQuery } from 'react-query'
import { useContext } from 'react'

import { api } from '@h2/api'
import { Link } from '@h2/common/components/link'
import { Loader } from '@h2/components/loading/loader'
import { usePageTitle } from '@h2/common/components/hooks/usePageTitle'
import { Globals } from '@h2/globals'

import { Heading } from '../../components/typography/heading'

const ClusterListing = ({ listMajors = false }) => {
  const { clusterTaxonomyTitle } = useContext(Globals)

  usePageTitle(clusterTaxonomyTitle)
  const { data: clusterListing, isLoading } = useQuery(
    ['cluster-listing', listMajors],
    () => {
      return api.fetch(`/pathways/clusters${listMajors ? '?type=major' : ''}`, {
        method: 'GET',
        version: 'v1'
      })
    }
  )
  const genLink = ({ url, id, name }) => {
    if (url.indexOf('/detail/') >= 0) {
      return (
        <Link href={url} className={`cluster-${id.replace('.', '-')}`}>
          <span className="cluster">
            <span>{name}</span>
          </span>
        </Link>
      )
    }

    return (
      <Link href={url} className={`cluster-${id.replace('.', '-')}`}>
        <span className="cluster">
          <span>{name}</span>
        </span>
      </Link>
    )
  }

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className="container" id="cluster-listing">
      <Heading level="2" mb="50px" align="center" weight="light">
        <span>{t`Select an option below to learn more about the opportunities within it.`}</span>
      </Heading>

      <div className={`clusters cluster-${clusterListing.taxonomy}`}>
        <div className="listholder">
          <ul className="list">
            {clusterListing.clusters.map((cluster, idx) => (
              <li className="list-item" key={cluster.id}>
                <span className={`list-item-column list-item-column${idx}`}>
                  {genLink(cluster)}
                  &nbsp;
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export { ClusterListing }
